const win: any = window;

export const auditErrorRequest = (SequenceManager: any, shoppingCartId: any, currentSection: any) => {
    const { error } = SequenceManager;
    const errorData = error?.response ? error?.response : error;
    const auditJourneyName = win.auditJourneyName ? win.auditJourneyName : SequenceManager?.journeyName;
    const auditXCorrelationId = win.auditXCorrelationId ? win.auditXCorrelationId : SequenceManager?.xCorrelationId;
    const auditScId = win.auditScId ? win.auditScId : shoppingCartId;
    const createdOnDate = errorData?.config?.headers['X-Timestamp'] ? errorData?.config?.headers['X-Timestamp'] : '';
    const transactionId = errorData?.config?.headers['X-Transaction-Id'] ? errorData?.config?.headers['X-Transaction-Id'] : "No Trans Id";
    const correlationId = errorData?.config?.headers['X-Correlation-Id'] ? errorData?.config?.headers['X-Correlation-Id'] : auditXCorrelationId;
    const xSourceChannel = errorData?.config?.headers["X-Source-Channel"] ? errorData?.config?.headers["X-Source-Channel"] : "PORTAL";
    const statusCode = win.auditStatusCode ? win.auditStatusCode : errorData?.status;

    sessionStorage.setItem('xcoorelationid-error', correlationId);
    sessionStorage.setItem('transactionid-error', transactionId);
    sessionStorage.setItem('journeyname-error', auditJourneyName);
    sessionStorage.setItem('stepname-error', currentSection ? currentSection : 'eCommerce');
    sessionStorage.setItem('errorcode-error', statusCode ? statusCode : 'No statusCode from Backend');

    const safeParse = (data: any) => {
        try {
            return JSON.parse(data);
        } catch {
            return data || "";
        }
    };

    const { config, request } = errorData;
    const url = config?.serviceName ? config?.serviceName : (config?.url.length > 0 ? getServiceName(config?.url) : 'eCommerce');

    const responseMsg = statusCode ? `Customer Connection Rest ${statusCode}` : "Customer Connection Rest";
    const req = {
        "ServiceName": url,
        "JourneyName": auditJourneyName,
        "EndpointURL": request?.responseURL ? request?.responseURL : config?.baseURL + config?.url,
        "ShoppingCartId": auditScId,
        "TransactionId": transactionId,
        "CorrelationId": correlationId,
        "SourceId": "PORTAL_CLIENT",
        "JsonRequest": config?.data ? safeParse(config?.data) : "",
        "JsonResponse": request?.response ? safeParse(request?.response) : responseMsg,
        "BackendRequestType": "MQ",
        "BackendRequest": "",
        "BackendResponse": "",
        "RequestQueueName": "",
        "ResponseQueueName": "",
        "BackendURL": "",
        "Payload": {
            "header": [
                { Method: config?.method.toUpperCase(), ...config?.headers }
            ]
        },
        "HTTPHeaders": {
            "header": [
                {
                    "name": "X-Correlation-Id",
                    "value": correlationId
                },
                {
                    "name": "X-Source-Channel",
                    "value": xSourceChannel
                },
                {
                    "name": "X-Transaction-Id",
                    "value": transactionId
                }
            ]
        },
        "CreatedOn": createdOnDate,
        "ProcessingTime": 0,
        "Status": statusCode ? statusCode.toString() : 'no Status code'
    }
    return req;
}

const getServiceName = (url: any) => {
    const part = url.split('/').pop();
    let serviceName = part;

    if (part.includes('?')) {
        serviceName = part.split('?')[0];
    }

    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
    if (uuidRegex.test(part)) {
        const arr = url.split('/')
        serviceName = arr[arr.length - 2];
    }

    return serviceName;
}